<div class="container py-4" *ngIf="line">
  <h2>{{ line.name }}</h2>
  <h5 class="mt-3">Versiones</h5>

  <div class="row g-3">
    <div class="col-md-4" *ngFor="let v of versions">
      <a class="card h-100 p-3" [routerLink]="['/software', line.slug, v.version.toLowerCase()]">
        <h6 class="mb-2">{{ v.version }}</h6>
        <ul class="small mb-0"><li *ngFor="let f of v.features">{{ f }}</li></ul>
      </a>
    </div>
  </div>
</div>
